export default __webpack_public_path__ + "static/media/FiraSans-BoldItalic.c375da8f.woff";